import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import config from "../../Common/Configurations/APIConfig";
import LayoutHeader from "../../Common/Layout/Header";
import LayoutSideBar from "../../Common/Layout/Sidebar";
import moment from "moment";
import UserManagement from "../../Components/Masters/Users";

export default function AdminDashboard() {
  const [lists, setLists] = useState([]);
  const [showUserModal, setShowUserModal] = useState(false);
  const [data, setData] = useState([]);
  const [taskStatusCounts, setTaskStatusCounts] = useState({});
  const userId = localStorage.getItem("userId");
  const headerconfig = {
    headers: { Authorization: "Bearer " + localStorage.getItem("userToken") },
  };
  const GetData = () => {
    axios
      .get(
        config.APIACTIVATEURL + config.GETTODAYATTENDANCE + "?userId=" + userId,
        {
          ...headerconfig,
        }
      )
      .then((response) => {
        setLists(response.data.data.data);
        setData(response.data.data);
      });
  };
  const GetTaskStatusCounts = () => {
    axios
      .get(config.APIACTIVATEURL + config.STATUSCOUNTS + "?userId=" + userId, {
        ...headerconfig,
      })
      .then((response) => {
        setTaskStatusCounts(response.data.data);
      });
  };
  useEffect(() => {
    GetData();
    GetTaskStatusCounts();
  }, []);
  return (
    <div id="layout-wrapper">
      <LayoutHeader />
      <LayoutSideBar />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row mb-3 pb-1">
              <div className="col-12">
                <div className="d-flex align-items-lg-center flex-lg-row flex-column">
                  <div className="flex-grow-1">
                    <h4 className="fs-16 mb-1">
                      Good Morning{" "}
                      <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
                        {localStorage.getItem("name")}
                      </span>
                    </h4>
                    <p className="text-muted mb-0">
                      Here's what's happening today.
                    </p>
                  </div>
                  <div className="mt-3 mt-lg-0">
                    <button
                      type="button"
                      className="btn btn-success me-2"
                      onClick={() => setShowUserModal(true)}
                    >
                      Create Users
                    </button>
                  </div>
                  <div className="mt-3 mt-lg-0">
                    <form action="javascript:void(0);">
                      <div className="row g-2 mb-0 align-items-center">
                        <div className="col-auto">
                          <Link to={"/staff"} className="btn btn-primary">
                            Create Staff
                          </Link>
                        </div>
                        <div className="col-auto">
                          <Link to={"/allClients"} className="btn btn-info">
                            Create Client
                          </Link>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div className="row row-cols-xxl-5 row-cols-lg-3 row-cols-sm-2 row-cols-1">
              <div className="col-lg-3">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex align-items-center mb-2">
                      <div className="flex-grow-1">
                        <h4 className="text-muted mb-0">Total Tasks</h4>
                      </div>
                      <div className="flex-shrink-0 avatar-sm">
                        <div className="avatar-title bg-warning text-white fs-22 rounded">
                          {taskStatusCounts.totalServiceTasks}
                        </div>
                      </div>
                    </div>
                    <Link
                      to="/servicetaskreports"
                      className="text-warning"
                      title="View Details"
                    >
                      <i className="ri-eye-fill align-middle"></i> View Details
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex align-items-center mb-2">
                      <div className="flex-grow-1">
                        <h4 className="text-muted mb-0">Completed Tasks</h4>
                      </div>
                      <div className="flex-shrink-0 avatar-sm">
                        <div className="avatar-title bg-success text-white fs-22 rounded">
                          {taskStatusCounts.completed}
                        </div>
                      </div>
                    </div>
                    <Link
                      to="/servicetaskreports"
                      className="text-success"
                      title="View Details"
                    >
                      <i className="ri-eye-fill align-middle"></i> View Details
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex align-items-center mb-2">
                      <div className="flex-grow-1">
                        <h4 className="text-muted mb-0">Pending Tasks</h4>
                      </div>
                      <div className="flex-shrink-0 avatar-sm">
                        <div className="avatar-title bg-danger fs-22 rounded">
                          {taskStatusCounts.pending}
                        </div>
                      </div>
                    </div>
                    <Link
                      to="/servicetaskreports"
                      className="text-danger"
                      title="View Details"
                    >
                      <i className="ri-eye-fill align-middle"></i> View Details
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex align-items-center mb-2">
                      <div className="flex-grow-1">
                        <h4 className="text-muted mb-0">Staffs</h4>
                      </div>
                      <div className="flex-shrink-0 avatar-sm">
                        <div className="avatar-title bg-primary text-white fs-22 rounded">
                          {taskStatusCounts.staff}
                        </div>
                      </div>
                    </div>
                    <Link
                      to="/staff"
                      className="text-primary"
                      title="View Details"
                    >
                      <i className="ri-eye-fill align-middle"></i> View Details
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex align-items-center mb-2">
                      <div className="flex-grow-1">
                        <h4 className="text-muted mb-0">Clients</h4>
                      </div>
                      <div className="flex-shrink-0 avatar-sm">
                        <div className="avatar-title bg-info text-white fs-22 rounded">
                          {taskStatusCounts.clients}
                        </div>
                      </div>
                    </div>
                    <Link
                      to="/allClients"
                      className="text-info"
                      title="View Details"
                    >
                      <i className="ri-eye-fill align-middle"></i> View Details
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-xl-12">
                <div className="card card-height-100">
                  <div className="card-header align-items-center d-flex">
                    <h4 className="card-title mb-0 flex-grow-1">
                      Today's Attendance
                    </h4>
                  </div>
                  <div className="card-body">
                    <div className="table-responsive table-card">
                      <table className="table align-middle">
                        <thead className="table-light">
                          <tr>
                            <th>S.No</th>
                            <th>Staff</th>
                            <th>Attendance Date</th>
                            <th>CheckIn</th>
                            <th>CheckOut</th>
                            <th>TotalHoursWorked</th>
                            <th>TotalOverTime</th>
                          </tr>
                        </thead>
                        <tbody>
                          {lists.map((v, index) => (
                            <tr key={v.attendanceId}>
                              <td>{index + 1}</td>
                              <td>{v.staffName}</td>
                              <td>
                                {moment(v.attendanceDate).format("DD-MMM-YYYY")}
                              </td>
                              <td>{moment(v.checkIn).format("hh:mm a")}</td>
                              <td>
                                {v.checkOut === "0001-01-01T00:00:00" ||
                                !v.checkOut
                                  ? "--"
                                  : moment(v.checkOut).format("hh:mm a")}
                              </td>
                              <td>
                                {Math.floor(v.totalWorkingHours)}h :
                                {Math.round((v.totalWorkingHours % 1) * 60)
                                  .toString()
                                  .padStart(2, "0")}
                                m
                              </td>
                              <td>
                                {Math.floor(v.totalOverTime)}h :
                                {Math.round((v.totalOverTime % 1) * 60)
                                  .toString()
                                  .padStart(2, "0")}
                                m
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showUserModal && (
        <UserManagement
          onClose={() => setShowUserModal(false)}
          headerconfig={headerconfig}
        />
      )}
    </div>
  );
}
